import EmptyStar from '@images/EmptyStar.svg';
import HalfStarIcon from '@images/Halfstar.svg';
import StarIcon from '@images/Star.svg';
import React from 'react';

export interface StarRatingProps {
  className?: string;
  rating?: number;
  halfRating?: number;
  total?: number;
  isInteractive?: boolean;
  onChange?: (val: number) => void;
}

const StarRating: React.FunctionComponent<StarRatingProps> = ({
  className = '',
  rating = 0,
  total,
  halfRating = 0,
  isInteractive = false,
  onChange,
}) => {
  return (
    <div className={`flex ${className}`}>
      {new Array(rating).fill(rating).map((value, index) => (
        <img
          src={StarIcon}
          alt="Star Rating"
          className="mr-4 h-20 w-20"
          key={`active-${index}`}
          onClick={() => {
            if (isInteractive) {
              onChange(index + 1);
            }
          }}
        />
      ))}
      {halfRating ? <img src={HalfStarIcon} alt="Star Rating" className="mr-4 h-18" /> : null}
      {new Array(total - (rating + halfRating)).fill(total - (rating + halfRating)).map((value, index) => (
        <img
          src={EmptyStar}
          alt="Star Rating"
          className="mr-4 h-20"
          style={{ filter: 'brightness(1.3)' }}
          key={`empty-${index}`}
          onClick={() => {
            if (isInteractive) {
              onChange(rating + index + 1);
            }
          }}
        />
      ))}
    </div>
  );
};

export default StarRating;
